import { CmsIcon } from '@domgen/dgx-fe-cms';
import { AccordionPanel } from '@domgen/dgx-fe-components/accordion';

export interface ProtectionBenefitsAccordionPanel extends AccordionPanel {
  icon?: CmsIcon;
  subtitle?: string;
}
